import decodeHtmlEntities from '../../../shared/utils/decodeHtmlEntities';

/**
 * Builds the single combined subtext string for a `'both'`-info-category
 * calendar item (Circuit / SAQ+C cardio) as shown in the expanded / preSave
 * view. The pieces are additional info, the circuit subtitle, and the
 * description, space-joined with no field labels.
 *
 * The subtlety this encodes: a saved circuit's server-provided `subTitle` is
 * "<detail> - <description>", i.e. it already contains the description. So we
 * render `subTitle` and only append the standalone `description` when `subTitle`
 * does not already include it. That covers:
 *   - non-circuit `'both'` items (cardio) — no `subTitle` is used, description shown once;
 *   - preSave circuits — whose `subTitle` is the detail prefix only (no description);
 * while preventing a saved circuit's description from rendering twice.
 *
 * `localAdditionalInfo` / `localDescription` are the component's optimistic
 * edit overrides and win over the persisted fields when present.
 *
 * @param {object} item - calendar content / modalData object
 * @param {{ localAdditionalInfo?: string, localDescription?: string }} [overrides]
 * @returns {string}
 */
const buildBothInfoText = (item, { localAdditionalInfo, localDescription } = {}) => {
  const isCircuit = item?.type === 'circuit' || item?.type === 'C';
  const subTitleText = isCircuit ? decodeHtmlEntities(item?.subTitle) : null;
  const descriptionText = localDescription || decodeHtmlEntities(item?.description);
  const descriptionPart = subTitleText && descriptionText && subTitleText.includes(descriptionText)
    ? null
    : descriptionText;

  return [
    localAdditionalInfo
      || decodeHtmlEntities(item?.additionalInfo)
      || decodeHtmlEntities(item?.exercise?.additionalInfo),
    subTitleText,
    descriptionPart,
  ].filter(Boolean).join(' ');
};

export default buildBothInfoText;
